import { StyledSpinnerNext } from "baseui/spinner";

export const Fallback: React.FC = () => {
  return (
    <div className="fixed inset-0 z-10 flex items-center justify-center w-screen h-screen">
      <StyledSpinnerNext size="24px" />
    </div>
  );
};
